module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.22147/js/img/productIcons/ServiceHub_Starter.svg"